import { Component, ContentChild } from '@angular/core';
import { AccordionHeaderComponent } from '../accordion-header/accordion-header.component';
import { AccordionContentComponent } from '../accordion-content/accordion-content.component';

@Component({
  selector: 'app-accordion-group',
  templateUrl: 'accordion-group.component.html',
  standalone: true,
})
export class AccordionGroupComponent {
  @ContentChild(AccordionHeaderComponent, { static: true })
  header: AccordionHeaderComponent;

  @ContentChild(AccordionContentComponent, { static: true })
  content: AccordionContentComponent;
}
